import user from '@/api/modules/user'
import allocation from '@/api/modules/allocation'
import { REFUSED_STATUS, TABLE_PENDING_STATUS, WEALTH_DECISION_TYPE } from '@/constants/arbitration'
import { AppHolder } from '@/utils/app-holder'
import { i18n } from '@/plugins/i18n'

const getDefaultState = () => {
  return {
    arbitrationsPending: []
  }
}

const state = getDefaultState()

const actions = {
  fetchArbitrationsPending (context) {
    return user.fetchArbitrationsAndWealthDecision(1, 10, [TABLE_PENDING_STATUS])
      .then(results => {
        const { data } = results
        const arbitrations = data || null
        context.commit('fetchArbitrationsPending', arbitrations)
      })
  },
  refuseArbitrationOrWealthDecision (context, { id, contractId, arbitrationType }) {
    const functionUpdateStatus = WEALTH_DECISION_TYPE === arbitrationType ? 'updateWealthDecisionStatus' : 'updateArbitrationStatus'
    return allocation[functionUpdateStatus](id, contractId, REFUSED_STATUS).then(() => {
      AppHolder.store.dispatch('toasts/addMessage', {
        component: 'app-toast',
        body: i18n.t(`arbitration.dialog-decline.${arbitrationType.replaceAll('_', '-')}.toast-confirmation`)
      })
    })
  }
}

const mutations = {
  fetchArbitrationsPending (state, arbitrations) {
    state.arbitrationsPending = arbitrations
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
